import { FC } from 'react';
import { ProviderField } from '../../models/provider';
import { SubmitProviderInputsPayload } from '../screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { PageView, UserInteractionEvent } from '../../models/analytics';
import { usePageViewEvents } from '../../core/Analytics/usePageViewEvents';
import { ChipTanTemplateView } from './ChipTanTemplateView';

export type ChipTanTemplateScreenProps = {
  fields: ProviderField[];
  onSubmit: (values: SubmitProviderInputsPayload) => void;
};

export const ChipTanTemplateScreen: FC<ChipTanTemplateScreenProps> = ({ fields, onSubmit }) => {
  const { sendViewInteractionEvent } = usePageViewEvents({
    pageView: PageView.CHIP_TAN_TEMPLATE_SCREEN,
  });

  const handleSubmitWithAnalytics = (values: SubmitProviderInputsPayload) => {
    sendViewInteractionEvent({ interaction: UserInteractionEvent.SUBMIT_SUPPLEMENTAL_INFORMATION });
    onSubmit(values);
  };

  return <ChipTanTemplateView onSubmit={handleSubmitWithAnalytics} fields={fields} />;
};
